import * as SystemActions from 'src/app/store/system/actions/system.actions';
import * as AuthActions from 'src/app/store/auth/actions/auth.actions';
import * as ClientActions from 'src/app/store/client/actions/client.actions';
import { initialClientState, IClientState } from 'src/app/store/state/client.state';
import { EntitySubType, EntityType } from 'src/app/models/entityTypes';

export interface IClient {
    GroupId: number;
    GroupName: string;
    Members: IEntity[];
    EntityId?: number;
    EntityType?: EntityType;
    EntitySubType?: EntitySubType;
}

export interface IEntity {
    EntityId: number;
    Name: string;
    NetAssetValue: any;
    NetAssetRefValue: any;
    EntityType?: EntityType;
    EntitySubType?: EntitySubType;
}

export interface IClientSearchModel {
    query: string,
    entitySubType: number
}

export function ClientReducer (state = initialClientState, action: ClientActions.ClientActions | AuthActions.AuthActions | SystemActions.SystemActions): IClientState {
    switch (action.type) {
        case ClientActions.SET_INITIAL_CLIENT_GROUPS:
            return {
                ...state,
                clientGroups: (action.payload !== null) ? action.payload : state.clientGroups,
                doesDefaultClientListExist: true,
                needClientBeSelected: true
            };
        case ClientActions.SET_CLIENT_GROUPS:
            return {
                ...state,
                clientGroups: (action.payload !== null) ? action.payload : state.clientGroups,
                doesDefaultClientListExist: false,
                needClientBeSelected: true
            };
        case ClientActions.SET_SELECTED_CLIENT_GROUP:
            return {
                ...state,
                selectedClientGroup: {
                    GroupId: action.payload.selectedClient.GroupId,
                    GroupName: action.payload.selectedClient.GroupName,
                    Members: []
                },
                selectedClientName: action.payload.selectedClient.GroupName,
                needClientBeSelected: false,
                loading: true,
                error: false
            };
        case ClientActions.SET_SELECTED_SINGLE_ENTITY_CLIENT:
            return {
                ...state,
                selectedClientGroup: {
                    ...state.selectedClientGroup,
                    Members: [{
                        ...action.payload.selectedClient,
                        EntityId: action.payload.selectedClient.EntityId,
                        Name: action.payload.selectedClient.GroupName,
                        NetAssetValue: 0,
                        NetAssetRefValue: 0,
                        EntitySubType: action.payload.selectedClient.EntitySubType,
                        EntityType: action.payload.selectedClient.EntityType
                    }],
                    GroupId: null // this has to be set to null, to enable switching between two clients where one has a groupId and the other is a single entity client.
                },
                selectedClientName: action.payload.selectedClient.GroupName,
                needClientBeSelected: false,
                loading: true,
                error: false
            };
        case ClientActions.SET_SELECTED_CLIENT_GROUP_ENTITIES:
            return {
                ...state,
                selectedClientGroup: {
                    ...state.selectedClientGroup,
                    Members: action.payload.members
                },
                needClientBeSelected: false,
                selectedDate: action.payload.selectedDate,
                isEntityDateDataUpdated: (action.payload.updateEntityDateData) ? action.payload.updateEntityDateData : false,
                multiSelect: ( action.payload.multiSelect !== undefined) ? action.payload.multiSelect : state.multiSelect,
                loading: false
            };
        case ClientActions.UPDATE_ENTITY_DATE_DATA:
            return {
                ...state,
                loading: true,
                error: false
            };
        case ClientActions.GET_CLIENT_GROUPS:
        case ClientActions.GET_CLIENT_INVESTOR_ENTITIES:
            return {
                ...state,
                error: false
            };
        case ClientActions.CLIENT_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload
            };
        case ClientActions.GET_AVAILABLE_POSITIONS:
            return {
                ...state,
                loading: true
            };
        case ClientActions.SET_AVAILABLE_POSITIONS:
            return {
                ...state,
                availablePositions: action.payload,
                loading: false
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialClientState;
        default:
            return state;
    }
}
